@if ((store.isSummary() | async) === false && activeOption !== incomeOption.INCOME_INPUT) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
}

@switch (activeOption) {
    @case (incomeOption.INCOME_INPUT) {
        <income-input></income-input>
    }
    @case (incomeOption.DATE_OF_BIRTH) {
        <date-of-birth></date-of-birth>
    }
    @case (incomeOption.AOW10YEARS_INFO) {
        <aow-info></aow-info>
    }
    @case (incomeOption.STARTERS_DISPENSATION) {
        <starters-dispensation></starters-dispensation>
    }
    @case (incomeOption.STARTERS_DISPENSATION_INFO) {
        <starters-dispensation-info></starters-dispensation-info>
    }
    @case (incomeOption.SUMMARY) {
        <income-input></income-input>

        <hr />
        <date-of-birth></date-of-birth>

        @if (store.showStartersDispensation()) {
            <hr />
            <starters-dispensation></starters-dispensation>
        }
    }
}
